import { Component, Input, OnChanges, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { DynamicFormArray, Props, TabConfig, TabGroupConfig } from '../../model/form.model';
import { DataTableSchema } from '../../model/dynamic-data-table.model';
import { LAYOUT_TYPE, LayoutType } from '../../model/common.model';
import { TabsComponent } from '../tabs/tabs.component';
import { FilterListContainerComponent } from '../filter-list-container/filter-list-container.component';
import { CommonModule } from '@angular/common';
import { BreadcrumsComponent } from "../../components/breadcrums/breadcrums.component";
import { breadrums } from '../../model/breadcrum.model';
import { DashboardContainerComponent } from '../dashboard-container/dashboard-container.component';

@Component({
  selector: 'app-page-container',
  standalone: true,
  imports: [CommonModule, TabsComponent, FilterListContainerComponent, BreadcrumsComponent],
  templateUrl: './page-container.component.html',
  styleUrl: './page-container.component.scss'
})
export class PageContainerComponent implements OnInit, OnChanges {

  @Input() DataTableSchema!: DataTableSchema;
  @Input() title!: string;
  @Input() dynamicFormArray!: DynamicFormArray;
  @Input() label!: string;
  @Input() dataTransform?: (response: any) => any[];
  @Input() props: Props = {
    isTabStretch: true
  };
  @Input() tabConfig: Array<TabConfig> = [];
  @Input() layoutType: LayoutType = LAYOUT_TYPE.List;
  @Input() isLoading = false;
  @Input() showBreadcrumb = true;
  @Input() breadcrumbProps?: any;
  @Input() groups: TabGroupConfig[] = [];
  @Input() selectedGroupIndex = 0;
  @Input() onGroupChange: (index: number) => void = () => undefined;
  @Output() tabChange = new EventEmitter<number>();
  readonly LayoutType: typeof LAYOUT_TYPE = LAYOUT_TYPE;
  public beginRender = false;
  breadcrumList: Array<breadrums> = [];
  public selectedTabIndex = 0;
  public visitedTabs = new Set<number>();

  // Handler for breadcrums tab click
  onBreadcrumTabChange = (tab: TabConfig) => {
    const idx = this.tabConfig.findIndex(t => t.tabId === tab.tabId);
    if (idx !== -1) {
      this.onTabChange(idx);
    }
  };
  ngOnInit() {
    this.beginRender = true;
    this.visitedTabs.add(0);
    this.syncBreadcrumbTitle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['title']) {
      this.syncBreadcrumbTitle();
    }
  }

  private syncBreadcrumbTitle(): void {
    if (this.title) {
      this.breadcrumList = [{ level: 1, name: this.title || '' }]
    }
  }

  onTabChange(tabIndex: number): void {
    this.tabChange.emit(tabIndex);
    this.setTab(tabIndex);
    this.triggerTabSubject(tabIndex);
  }

  setTab(tabIndex: number): void {
    this.visitedTabs.add(tabIndex);
    this.selectedTabIndex = tabIndex;
  }

  private triggerTabSubject(tabIndex: number): void {
    const selectedTab = this.tabConfig?.[tabIndex];
    if (selectedTab?.['tabOnChangeSubject']) {
      selectedTab['tabOnChangeSubject'].next('TabSelected');
    }
  }

  getTabInputs(idx: number): Record<string, unknown> | undefined {
    const tab = this.tabConfig[idx];
    const inputs = (tab?.inputs as unknown as Record<string, unknown>) ?? {};
    if (tab?.component === DashboardContainerComponent && tab?.['tabInfoText']) {
      return { ...inputs, tabInfoText: tab['tabInfoText']};
    }
    return inputs;
  }
}
